import { systemStore, setRouteHidesTitleBar } from 'kuaidong-store'

/** 路由 meta.hideTitleBar：进页藏校园端全局顶栏，离开后按 App / 小程序规则恢复。 */
export const syncTitleBarByRouteMeta = (
  _toMeta?: { hideTitleBar?: boolean },
  _fromMeta?: { hideTitleBar?: boolean }
) => {
  const hideTo = !!_toMeta?.hideTitleBar
  const hideFrom = !!_fromMeta?.hideTitleBar
  if (!hideTo && !hideFrom) return

  setRouteHidesTitleBar(hideTo)
  if (hideTo) {
    systemStore.setTitleBarVisible(false)
  }
  void systemStore.initTitleBarVisible()
}
